import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtError } from "@/lib/api";
import { AuthShell, Field } from "@/components/AuthShell";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(fmtError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  if (sent)
    return (
      <AuthShell title="Check your email" subtitle="If an account exists for that email, we've sent password reset instructions.">
        <div className="ll-fade-up flex flex-col items-center text-center gap-4 py-4">
          <MailCheck className="w-14 h-14 text-[#16A34A]" />
          <p className="text-[#111827]/70" data-testid="forgot-honest-note">Email delivery is not enabled in this competition build. Please use Google Sign-In, Phone Test Access, or contact the administrator.</p>
          <Link to="/auth/sign-in" data-testid="back-to-signin" className="w-full bg-[#F97316] text-white rounded-2xl py-4 font-bold min-h-[56px] flex items-center justify-center">Back to Sign In</Link>
        </div>
      </AuthShell>
    );

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll help you get back in.">
      <form onSubmit={submit} className="ll-fade-up">
        <Field label="Email" testId="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
        {error && <p className="text-[#DC2626] text-sm font-medium mb-4 bg-[#DC2626]/10 rounded-xl p-3">{error}</p>}
        <button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full bg-[#F97316] text-white rounded-2xl py-4 font-bold text-lg min-h-[56px] flex items-center justify-center disabled:opacity-70">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Send reset link"}
        </button>
      </form>
      <p className="text-center mt-8"><Link to="/auth/sign-in" className="font-bold text-[#F97316]">Back to sign in</Link></p>
    </AuthShell>
  );
}
